var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-scrollbar',{ref:"scrollbar",staticClass:"rap-scrollbar"},[_c('span',{attrs:{"id":"AppAnchorId"}}),(!_vm.$route.meta.nolayout)?_c('layout'):_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }